import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "../styles/markets.css";
import Graph from "./Graph";
import india, { global, currencies, commodities } from "../data/market_data";
import Stocks from "./Stocks";
import WatchList from "./WatchList";

const Markets = () => {
  const api_key = "0QfOX3Vn51YCzitbLaRkTTBadtWpgTN8NZLW0C1SEM";
  const [indiaData, setindiaData] = useState(india);
  const [globalData, setglobalData] = useState(global);
  const [currenciesData, setcurrenciesData] = useState(currencies);
  const [commoditiesData, setcommoditiesData] = useState(commodities);

  const [cardData, setCardData] = useState(indiaData);
  const [activeCard, setActiveCard] = useState("India");

  const [instrumentId, setinstrumentId] = useState("ahkqww");

  const [graphName, setgraphName] = useState("NIFTY");
  const [graphPrice, setgraphPrice] = useState("");
  const [graphPriceChange, setgraphPriceChange] = useState("");
  const [graphPriceChangePercentage, setgraphPriceChangePercentage] =
    useState("");

  async function fetchFinanceData() {
    const indiaIds = india.map((item) => item.instrumentId);
    const globalIds = global.map((item) => item.instrumentId);
    const currenciesIds = currencies.map((item) => item.instrumentId);
    const commoditiesIds = commodities.map((item) => item.instrumentId);
    const ids = [
      ...indiaIds,
      ...globalIds,
      ...currenciesIds,
      ...commoditiesIds,
    ].join(",");
    try {
      const url = new URL(
        `https://assets.msn.com/service/Finance/Quotes?apikey=${api_key}&activityId=1A974D4D-7189-42E2-9673-EB182323EDA6&ocid=finance-utils-peregrine&cm=en-in&ids=${ids}&wrapodata=false`
      );
      const response = await fetch(url);
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      const json = await response.json();

      // update india data
      for (let i = 0; i < indiaIds.length; ++i) {
        json.forEach((array) => {
          const object = array.find(
            (item) => item.instrumentId === indiaIds[i]
          );
          if (object) {
            // console.log(object);
            setindiaData([
              ...indiaData,
              (indiaData[i].price = object.price),
              (indiaData[i].priceChange = object.priceChange),
              (indiaData[i].priceChangePercent =
                "(" + object.priceChangePercent.toFixed(2) + "%)"),
            ]);
            if (i === 0) {
              setgraphPrice(indiaData[i].price);
              setgraphPriceChange(indiaData[i].priceChange);
              setgraphPriceChangePercentage(indiaData[i].priceChangePercent);
            }
          }
        });
      }

      // update global data
      for (let i = 0; i < globalIds.length; ++i) {
        json.forEach((array) => {
          const object = array.find(
            (item) => item.instrumentId === globalIds[i]
          );
          if (object) {
            setglobalData([
              ...globalData,
              (globalData[i].price = object.price),
              (globalData[i].priceChange = object.priceChange),
              (globalData[i].priceChangePercent =
                "(" + object.priceChangePercent.toFixed(2) + "%)"),
            ]);
          }
        });
      }

      // update currencies data
      for (let i = 0; i < currenciesIds.length; ++i) {
        json.forEach((array) => {
          const object = array.find(
            (item) => item.instrumentId === currenciesIds[i]
          );
          if (object) {
            // console.log(object);
            setcurrenciesData([
              ...currenciesData,
              (currenciesData[i].price = object.price),
              (currenciesData[i].priceChange = object.priceChange),
              (currenciesData[i].priceChangePercent =
                "(" + object.priceChangePercent.toFixed(2) + "%)"),
            ]);
          }
        });
      }

      // update commoditiesIds data
      for (let i = 0; i < commoditiesIds.length; ++i) {
        json.forEach((array) => {
          const object = array.find(
            (item) => item.instrumentId === commoditiesIds[i]
          );
          if (object) {
            setcommoditiesData([
              ...commoditiesData,
              (commoditiesData[i].price = object.price),
              (commoditiesData[i].priceChange = object.priceChange),
              (commoditiesData[i].priceChangePercent =
                "(" + object.priceChangePercent.toFixed(2) + "%)"),
            ]);
          }
        });
      }
    } catch (error) {
      console.error("Network Error-->", error);
    }
  }

  const fetchData = async (period) => {
    try {
      await Promise.all([fetchFinanceData()]);
    } catch (error) {
      console.log("Network Error");
    }
  };
  useEffect(() => {
    fetchData();
    handleClick("India", india);
    const intervalId = setInterval(() => fetchData(), 10000);
    return () => clearInterval(intervalId);
  }, []);

  const handleClick = (buttonName, data) => {
    fetchData();
    setCardData(data);
    setActiveCard(buttonName);
  };

  const handleCardClick = (
    id,
    symbol,
    price,
    priceChange,
    priceChangePercent
  ) => {
    setinstrumentId(id);
    console.log("click in ->", id);
    setgraphName(symbol);
    setgraphPrice(price);
    setgraphPriceChange(priceChange);
    setgraphPriceChangePercentage(priceChangePercent);
  };

  return (
    <>
      <div className="market_dashboard">
        <div className="market_dashboard_title">
          <strong>
            <Link to="/" className="link_path">
              Home
            </Link>{" "}
            &gt; Market
          </strong>
          <h2>Market Dashboard</h2>
          <p>Track stock market indices and its companies.</p>
        </div>
        <div className="market_dashboard_cards">
          <Link className="nav_link">
            <div className="dashboard_card">Global Market</div>
          </Link>
          <Link className="nav_link">
            <div className="dashboard_card">Most Active</div>
          </Link>
          <Link className="nav_link">
            <div className="dashboard_card">Top Gainers</div>
          </Link>
          <Link className="nav_link">
            <div className="dashboard_card">Top Losers</div>
          </Link>
        </div>
      </div>

      <div className="dashboard_data_container">
        <div className="chart_container mr1">
          <div className="graph_container">
            <Graph instrumentId={instrumentId} />
          </div>

          <div className="card_container">
            <button
              className={`card_type_btn ${
                activeCard === "India" ? "active" : ""
              }`}
              onClick={() => handleClick("India", india)}
            >
              India
            </button>
            <button
              className={`card_type_btn ${
                activeCard === "Global" ? "active" : ""
              }`}
              onClick={() => handleClick("Global", global)}
            >
              Global
            </button>
            <button
              className={`card_type_btn ${
                activeCard === "Currencies" ? "active" : ""
              }`}
              onClick={() => handleClick("Currencies", currencies)}
            >
              Currencies
            </button>
            <button
              className={`card_type_btn ${
                activeCard === "Commodities" ? "active" : ""
              }`}
              onClick={() => handleClick("Commodities", commodities)}
            >
              Commodities
            </button>
            <div className="market_cards">
              {cardData.map((i) => {
                return (
                  <Link
                    key={i.id}
                    className="card_link"
                    onClick={() =>
                      handleCardClick(
                        i.instrumentId,
                        i.symbol,
                        i.price,
                        i.priceChange,
                        i.priceChangePercent
                      )
                    }
                  >
                    <div className="market_card">
                      <h6>{i.symbol}</h6>
                      <h5>{i.price}</h5>
                      <h6
                        style={{ color: i.priceChange < 0 ? "red" : "#04b03e" }}
                      >
                        {i.priceChange} {i.priceChangePercent}
                      </h6>
                    </div>
                  </Link>
                );
              })}
            </div>
          </div>
        </div>

        <Stocks />
      </div>
      <WatchList />
    </>
  );
};

export default Markets;
